<template>

  <teleport to="body">
    <div v-if="isLoading" class="modal">
      <div class="loading-content">
	<div class="loading-title">Uploading:</div>
	<div class="loading-message"><span>...</span></div>
      </div>
    </div>
  </teleport>
  
</template>

<script>
import { ref, defineComponent } from 'vue';
import router from '../router';

const isLoading = ref(false);

export const startLoading = () => {
    isLoading.value = true;
};

export const stopLoading = () => {
    isLoading.value = false;
};
	
export default defineComponent({
    setup() {

	isLoading.value = false;
    
	return {
	    isLoading,
	}
    }
});

</script>

<style scoped>
.modal {
    position: fixed;
    top: 0; right: 0; bottom: 0; left: 0;
    background-color: rgba(0,0,0,.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.loading-content {
    background-color: white;
    width: 300px;
}
.loading-title {
    display: inline-block;
    vertical-align: top;
    width: 20%;
}
.loading-message {
    display: inline-block;
    width: 80%;
    overflow: hidden;
}
.loading-message > span {
    display: inline-block;
    white-space: nowrap;
    padding-left: 100%;
    animation-name: MarqueeScroll;
    animation-timing-function: linear;
    animation-duration: 3s;
    animation-iteration-count: infinite;
}
@keyframes MarqueeScroll {
    from { transform: translateX(-90%); }
    to   { transform: translateX(0); }
}
</style>
